<template>
    <div class="content-blog">
        <div class="content-brand container">
            <GoToBackButton />
            <div class="content-brand-elements d-none d-lg-block">
                <router-link tag="a" :to="{ name: 'Home' }" class="content-brand-elements-links">
                    {{$t('pages.goToBackButton.start')}}
                </router-link>
                <span> > </span>
                <router-link tag="a" :to="{ name: 'Partners' }" class="content-brand-elements-links">
                    {{$t('pages.blog.title')}}
                </router-link>
            </div>
            <template v-if="titleAndDescription">
                <SocialSharing :title="post.title" :description="post.sort_description" class="d-lg-none"/>
            </template>
        </div>
        <div class="content-blog-img container">
            <img :src="post.image" alt="banner-blog" class="img-fluid" />
            <div class="content-blog-img-infos container">
                <div class="content-blog-img-info">
                    <div class="content-blog-img-info-label">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36.421" height="36.421"
                            viewBox="0 0 36.421 36.421">
                            <path id="Path_66" data-name="Path 66"
                                d="M7.007,15.56a1.4,1.4,0,0,1,1.96,0,1.4,1.4,0,0,1,.435,1.91,1.4,1.4,0,0,1-1.959,0,1.4,1.4,0,0,1-.435-1.91m11.686-1.106c1.105-1.244,2.342-2.427,3.485-3.622a.372.372,0,0,1,.521-.017l.393.362a.372.372,0,0,1,.025.522c-1.363,1.514-2.709,3.223-3.933,4.767-.168-.772-.338-1.45-.49-2.013m3.48,4.2a29.149,29.149,0,0,1,5.479-3.186.373.373,0,0,1,.5.183l.21.46a.371.371,0,0,1-.162.482,28.962,28.962,0,0,0-3.84,2.472,8.5,8.5,0,0,0-2.183-.411m-5.662,8.7a23.717,23.717,0,0,0-2.01-5.789.362.362,0,0,0-.287-.211c-2.439-.332-4.6-.6-7-.759a.372.372,0,0,1-.347-.386l.025-.6a.373.373,0,0,1,.385-.356c1.528.055,3.007.057,4.5.152.042,0,3.179.234,4.273,1.508.247.534.486,1.091.713,1.67.335.851-.124,3.78-.25,4.775m-3.456-8.547c-1.136-1.971-2.129-3.4-2.538-3.963a.37.37,0,0,1,.055-.5l.464-.411a.373.373,0,0,1,.521.026,25.633,25.633,0,0,1,3.475,4.931q.168.306.335.626a9.625,9.625,0,0,0-2.311-.713M19.344,7.818A1.4,1.4,0,0,1,20.36,9.494a1.4,1.4,0,0,1-1.408,1.362A1.4,1.4,0,0,1,17.936,9.18a1.4,1.4,0,0,1,1.408-1.362M29.916,6.5A16.555,16.555,0,1,0,6.5,29.916a5.572,5.572,0,0,0,.963.89c2.266,1.386,6.783.616,7.9.293.544-.157,1.045-.371,1.185-.92a32.024,32.024,0,0,0,.008-14.573,39.127,39.127,0,0,0-2.231-6.362.371.371,0,0,1,.156-.481l.528-.3a.372.372,0,0,1,.5.134,25.013,25.013,0,0,1,2.06,4.543,37.454,37.454,0,0,1,1.212,4.923H18.8c.129.793.23,1.617.294,2.464a.372.372,0,0,0,.629.24c.448-.433.886-.832,1.322-1.2a5.14,5.14,0,0,1,3.207.259l.04.017q.483.174.963.364c.213.091.34.153.342.154l.007-.014c1.269.513,2.526,1.083,3.775,1.6a.372.372,0,0,1,.2.479l-.168.428a.372.372,0,0,1-.474.213c-2.159-.792-4.514-1.459-6.649-2.115a.362.362,0,0,0-.354.075A22.813,22.813,0,0,0,19.358,23.7a.357.357,0,0,0-.087.222c-.007.151-.015.3-.023.443a28.867,28.867,0,0,0,.727,5.811,1.272,1.272,0,0,0,1.184.92c1.281.117,5.743,1.011,7.793-.293a6.028,6.028,0,0,0,.963-.89,16.555,16.555,0,0,0,0-23.411M18.21,0A18.211,18.211,0,1,1,5.334,5.334,18.154,18.154,0,0,1,18.21,0M31.173,18.873a1.571,1.571,0,0,0-3.017.534,1.571,1.571,0,0,0,3.017-.534"
                                fill="var( --green-medium)" />
                        </svg>
                        <p>{{$t('generic.gerasName')}}</p>
                    </div>
                    <div class="content-blog-img-info-date">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="36.571" viewBox="0 0 32 36.571">
                            <path id="Path_65" data-name="Path 65"
                                d="M28.571,4.571H25.143V.857A.86.86,0,0,0,24.286,0h-.571a.86.86,0,0,0-.857.857V4.571H9.143V.857A.86.86,0,0,0,8.286,0H7.714a.86.86,0,0,0-.857.857V4.571H3.429A3.429,3.429,0,0,0,0,8V33.143a3.429,3.429,0,0,0,3.429,3.429H28.571A3.429,3.429,0,0,0,32,33.143V8A3.429,3.429,0,0,0,28.571,4.571ZM3.429,6.857H28.571A1.146,1.146,0,0,1,29.714,8v3.429H2.286V8A1.146,1.146,0,0,1,3.429,6.857ZM28.571,34.286H3.429a1.146,1.146,0,0,1-1.143-1.143V13.714H29.714V33.143A1.146,1.146,0,0,1,28.571,34.286Zm-18-11.429H7.714A.86.86,0,0,1,6.857,22V19.143a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857V22A.86.86,0,0,1,10.571,22.857Zm6.857,0H14.571A.86.86,0,0,1,13.714,22V19.143a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857V22A.86.86,0,0,1,17.429,22.857Zm6.857,0H21.429A.86.86,0,0,1,20.571,22V19.143a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857V22A.86.86,0,0,1,24.286,22.857Zm-6.857,6.857H14.571a.86.86,0,0,1-.857-.857V26a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857v2.857A.86.86,0,0,1,17.429,29.714Zm-6.857,0H7.714a.86.86,0,0,1-.857-.857V26a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857v2.857A.86.86,0,0,1,10.571,29.714Zm13.714,0H21.429a.86.86,0,0,1-.857-.857V26a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857v2.857A.86.86,0,0,1,24.286,29.714Z"
                                fill="var( --green-medium)" />
                        </svg>
                        <p>{{ post.date }}</p>
                    </div>
                </div>
                <div class="content-blog-img-info-btn">
                    <button class="btn save-btn" :class="{'is-save': isSave}" v-if="userIsLogged" @click="toggleSave(post.title)">
                       <template v-if="isSave">
                                <p>{{$t('generic.saved')}}</p>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12.453" height="19.143" viewBox="0 0 12.453 19.143"><defs><clipPath id="a"><rect width="12.453" height="19.143" fill="#338545"/></clipPath></defs><g clip-path="url(#a)"><path d="M6.23,14.795a3.131,3.131,0,0,1-.206.27q-1.8,1.809-3.607,3.615a1.374,1.374,0,0,1-1.911.14A1.318,1.318,0,0,1,0,17.764Q0,9.923,0,2.083A2.071,2.071,0,0,1,2.1,0C3.446,0,4.794,0,6.141,0c1.391,0,2.781,0,4.172,0a2.078,2.078,0,0,1,2.119,1.779,2.252,2.252,0,0,1,.02.388q0,7.754,0,15.508a1.388,1.388,0,0,1-2.417,1Q8.231,16.873,6.43,15.063a2.81,2.81,0,0,1-.2-.269" transform="translate(0 0)" fill="#338545"/></g></svg>
                            </template>
                            <template v-else>				
                                <p>{{$t('generic.save')}}</p>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12.453" height="19.142" viewBox="0 0 12.453 19.142">
                                    <defs>
                                        <clipPath id="clip-path">
                                        <rect id="Rectangle_2194" data-name="Rectangle 2194" width="12.453" height="19.142" fill="#fff"/>
                                        </clipPath>
                                    </defs>
                                    <g id="Group_1864" data-name="Group 1864" clip-path="url(#clip-path)">
                                        <path id="Path_2920" data-name="Path 2920" d="M6.23,14.794a3.121,3.121,0,0,1-.206.27q-1.8,1.809-3.607,3.614a1.374,1.374,0,0,1-1.911.14A1.318,1.318,0,0,1,0,17.763Q0,9.923,0,2.083A2.071,2.071,0,0,1,2.1,0C3.446,0,4.793,0,6.141,0c1.391,0,2.781,0,4.172,0a2.078,2.078,0,0,1,2.119,1.779,2.247,2.247,0,0,1,.02.388q0,7.754,0,15.507a1.388,1.388,0,0,1-2.416,1Q8.231,16.873,6.43,15.063a2.821,2.821,0,0,1-.2-.269m4.841,2.959v-.237q0-7.669,0-15.337a.7.7,0,0,0-.776-.782q-4.065-.005-8.129,0a.708.708,0,0,0-.782.8q0,7.658,0,15.315c0,.061.007.121.011.182a.506.506,0,0,0,.195-.155q1.787-1.794,3.577-3.585a1.388,1.388,0,0,1,2.117-.007Q8.59,15.254,9.9,16.565c.377.378.751.759,1.174,1.187" transform="translate(0 0)" fill="#fff"/>
                                        <path id="Path_2921" data-name="Path 2921" d="M61.966,80.124c0-.456,0-.887,0-1.318a.694.694,0,1,1,1.382.006c0,.425,0,.851,0,1.312h.235c.375,0,.749,0,1.124,0a.7.7,0,0,1,.716.684.678.678,0,0,1-.688.706c-.452.015-.905,0-1.387,0,0,.466.008.911-.005,1.355a.893.893,0,0,1-.111.407.675.675,0,0,1-.772.293.7.7,0,0,1-.493-.664c0-.454,0-.907,0-1.388H60.916c-.122,0-.245,0-.367-.007a.7.7,0,0,1,.042-1.39c.446-.007.893,0,1.374,0" transform="translate(-56.43 -73.536)" fill="#fff"/>
                                    </g>
                                </svg>
                            </template>

                    </button>
                    <template v-if="titleAndDescription">
                        <SocialSharing :title="post.title" :description="post.sort_description" class="d-none d-lg-flex"/>
                    </template>
                </div>
            </div>
        </div>
        <div class="content-blog-article ">
            <div class="content-blog-article-title container">
                <h2>{{ post.title }}</h2>
            </div>
            <div class="content-blog-article-text " id="text-article" v-for="p, i  in post.text" :key="i">
                <p v-html="p.text" class="container"></p>
                <section class="content-news container-fluid" v-if="i == 6">
                    <div class="content-news-item container" v-if="publicities.image_fullpage == null">
                        <img class="img-fluid" src="@/assets/img/blog/news.png" alt="news" />
                    </div>
                    <a :href="publicities.image_fullpage_url" target="_blank" rel="noopener" class="content-news-item container" v-else>
                        <img class="img-fluid" :src="publicities.image_fullpage.path" alt="news" />
                    </a>
                </section>
            </div>
        </div>

        <section class="content-blog-comments container">
            <div class="content-blog-comments-header">
                <h2>{{$t('generic.comments')}}</h2>
                <button v-if="userIsLogged" 
                    class="btn btn-comments" 
                    @click="$bvModal.show('modal-comments')">
                    {{$t('generic.ourcomments')}}
                </button>
                <button v-else
                    class="btn btn-comments"
                    @click="alertLogin()">
                    {{$t('generic.ourcomments')}}
                </button>
            </div>
            <div v-if="showLess">
                <div class="content-blog-comments-body">
                    <div class="content-blog-comments-body-box" v-for="(comment, i) in comments.slice(0,3)" :key="i">
                        <div class="content-blog-comments-body-box-name">
                            <h3>{{ comment.user_name }}</h3>
                            <span>{{ comment.created_at }}</span>
                        </div>
                        <div class="content-blog-comments-body-box-text">
                            <p>{{ comment.comments }}</p>
                        </div>
                    </div>
                </div>
                <button class="btn btn-more" v-if="comments.length > 3" @click="showLess = false">Ver mais</button>
            </div>
            <div v-else>
                <div class="content-blog-comments-body">
                    <div class="content-blog-comments-body-box" v-for="(comment, i) in comments" :key="i">
                        <div class="content-blog-comments-body-box-name">
                            <h3>{{ comment.user_name }}</h3>
                            <span>{{ comment.created_at }}</span>
                        </div>
                        <div class="content-blog-comments-body-box-text">
                            <p>{{ comment.comments }}</p>
                        </div>
                    </div>
                </div>
                <button class="btn btn-more" @click="showLess = true">{{$t('generic.seeLess')}}</button>
            </div>
        </section>

        <section class="highlight container">
            <div class="content-title-highlight">
                <h2>{{$t('generic.otherdestaq')}}</h2>
            </div>
            <div class="row container">
                <a class="col-md-6 content-highlight" @click="goToPage(i.slug)" tag="a" v-for="(i, k) in blogall" :key="k">
									<div class="content-highlight-item">
											<img class="img-fluid" v-if="i.thumbnails.path" :src="i.thumbnails.path" alt="news" />
											<div class="content-highlight-item-text">
													<div class="content-highlight-item-text-date">
															<svg xmlns="http://www.w3.org/2000/svg" width="16.963" height="19.386"
																	viewBox="0 0 16.963 19.386">
																	<path id="Path_2815" data-name="Path 2815"
																			d="M15.145,2.423H13.328V.454A.456.456,0,0,0,12.874,0h-.3a.456.456,0,0,0-.454.454V2.423H4.847V.454A.456.456,0,0,0,4.392,0h-.3a.456.456,0,0,0-.454.454V2.423H1.817A1.818,1.818,0,0,0,0,4.241V17.569a1.818,1.818,0,0,0,1.817,1.817H15.145a1.818,1.818,0,0,0,1.817-1.817V4.241A1.818,1.818,0,0,0,15.145,2.423ZM1.817,3.635H15.145a.608.608,0,0,1,.606.606V6.058H1.212V4.241A.608.608,0,0,1,1.817,3.635Zm13.328,14.54H1.817a.608.608,0,0,1-.606-.606V7.27h14.54v10.3A.608.608,0,0,1,15.145,18.175ZM5.6,12.116H4.089a.456.456,0,0,1-.454-.454V10.147a.456.456,0,0,1,.454-.454H5.6a.456.456,0,0,1,.454.454v1.515A.456.456,0,0,1,5.6,12.116Zm3.635,0H7.724a.456.456,0,0,1-.454-.454V10.147a.456.456,0,0,1,.454-.454H9.239a.456.456,0,0,1,.454.454v1.515A.456.456,0,0,1,9.239,12.116Zm3.635,0H11.359a.456.456,0,0,1-.454-.454V10.147a.456.456,0,0,1,.454-.454h1.515a.456.456,0,0,1,.454.454v1.515A.456.456,0,0,1,12.874,12.116ZM9.239,15.751H7.724A.456.456,0,0,1,7.27,15.3V13.782a.456.456,0,0,1,.454-.454H9.239a.456.456,0,0,1,.454.454V15.3A.456.456,0,0,1,9.239,15.751Zm-3.635,0H4.089a.456.456,0,0,1-.454-.454V13.782a.456.456,0,0,1,.454-.454H5.6a.456.456,0,0,1,.454.454V15.3A.456.456,0,0,1,5.6,15.751Zm7.27,0H11.359A.456.456,0,0,1,10.9,15.3V13.782a.456.456,0,0,1,.454-.454h1.515a.456.456,0,0,1,.454.454V15.3A.456.456,0,0,1,12.874,15.751Z"
																			fill="var( --green-medium)" />
															</svg>
															<p>{{ blogall[k].date }}</p>
													</div>
													<h3 v-html="i.title"></h3>
													<p v-html="i.text "></p>
											</div>
											<button class="content-highlight-item-btn" @click="goToPage(i.slug)">
													<svg xmlns="http://www.w3.org/2000/svg" width="12.084" height="21.168"
															viewBox="0 0 12.084 21.168">
															<g id="Group_1413" data-name="Group 1413"
																	transform="translate(-7.584 10.584) rotate(-45)">
																	<path id="Union_2" data-name="Union 2" d="M18.168,0,9.084,9.084ZM0,0,9.084,9.084Z"
																			transform="translate(0 12.847) rotate(-45)" fill="none"
																			stroke="var( --green-medium)" stroke-linejoin="round" stroke-width="3" />
															</g>
													</svg>
											</button>
									</div>
                </a>
            </div>
        </section>
        <div class="content-brand container">
            <GoToBackButton />
        </div>
        <modal-comments></modal-comments>
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import ModalComments from '@/components/modals/ModalComments'
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue'
import GoToBackButton from "@/components/goToBackButton/GoToBackButton.vue";
import SocialSharing from "@/components/socialSharing/SocialSharing.vue";

export default {
    data() {
        return {
            showLess: true,
            post: {},
            slug: this.$route.params.slug,
            blogall: [],
            imgBlog: '',
            isSave: false,
            comments: [],
            titleAndDescription: false,
        }
    },
    computed: {
        ...mapGetters("User", ['userIsLogged']),
		...mapGetters({
			user: 'User/user',
			userFavorite: 'User/userFavorite',
            publicities: "Publicity/publicities",
        }),
    },

    components: {
        ModalComments, 
        GoToBackButton,
        SocialSharing,
    },
    methods: {
        ...mapActions({
			saveFavorite: 'User/saveFavorite',
			deleteFavorite: 'User/deleteFavorite',
			checkFavorite: 'User/checkFavorite',
		}),
        toggleSave(title){
			let objFavorite = { ...this.userFavorite };
			this.checkFavorite(objFavorite).then(resp => {
				if (!resp.data.success){
					let objSave = { ...objFavorite, title: title };
					this.saveFavorite(objSave).then(() => {
						this.isSave = true;
					}).catch((error) => {
						console.log('SAVE FAVORITE', error);
					});
				} else {
					let objDel = { access_token: objFavorite.access_token, fav_code: resp.data.fav_code }
					this.deleteFavorite(objDel).then(() => {
						this.isSave = false;
					}).catch((error) => {
						console.log('DELETE FAVORITE', error);
					});
				}
			}).catch((error) => {
				console.log('CHECK FAVORITE', error);
			});
		},
		toggleIsSave() {
			let objUser = { ...this.user, link: window.location.href }
			this.$store.dispatch('User/setUserFavorite', objUser).then(() => {
				let objFavorite = { ...this.userFavorite };
				this.checkFavorite(objFavorite).then(resp => {
					this.isSave = !resp.data.success ? false : true;
				}).catch((error) => {
					console.log('CHECK FAVORITE', error);
				});
			});
		},
        alertLogin() {
            Vue.fire({
            type: "info",
            title: "Atenção",
            text: "É necessário fazer login para comentar.",
            timer: 3000,
            showConfirmButton: true,
            })
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },

        goToPage(slug) {
            this.slug = slug
            this.$router.push({ name: 'BlogDetail', params: { slug: this.slug } })
            this.$router.go(0);
            // window.location.reload()
        },
    },
    async mounted() {
        this.$store.dispatch('Publicity/getPublicities', this.$route.name);
        axios.post('/api/v1/blog/post', { slug: this.slug })
            .then(response => {
                this.post = response.data;
                this.titleAndDescription = true;
                this.post.image = this.post.image.path
                this.image = this.post.image.path
                this.post.date = this.formatDate(this.post.created_at)
                this.post.text = this.post.text.replace(/\n/g, '<br>')
                this.post.text = this.post.text.split('<br>')
                this.post.text = this.post.text.map(i => {
                    return {
                        text: i
                    }
                })

            })
        axios.post('/api/v1/blog/all', { slug: this.slug })
            .then(resp => {
                this.blogall = resp.data
                for (let i = 0; i < this.blogall.length; i++) {
                    this.blogall[i].date = this.formatDate(this.blogall[i].created_at)
                }
            }).catch(error => {
                console.error("There was an error!", error);
            });

        axios.post('/api/v1/blog/getcomments', { slug: this.slug })
            .then(resp => {
                this.comments = resp.data
            }).catch(error => {
                console.error("There was an error!", error);
            });
        if (this.user){
			this.toggleIsSave();
		}
    },
}
</script>
<style lang="scss" scoped>
.content-blog {
    margin-top: 195px;
    margin-bottom: 100px;
    padding: 0;

    @media (max-width: 991px) {
        margin-top: 100px;
        margin-bottom: 38px;
    }

    .content-brand {
        @media (max-width: 991px) {
            justify-content: space-between;
        }

        .btn-return {
            width: 96px;
            height: 45px;
        }
    }

    .content-brand-elements {
        @media (max-width: 991px) {
            display: none;
        }
    }

    .content-brand-elements-share {
        display: none;

        @media (max-width: 991px) {
            display: block;
        }
    }
}
.content-blog-img {
    width: 100%;
    height: 100%;
    padding: 0;

    img {
        width: 100%;
        max-height: 350px;
        border-radius: 10px;
    }

    &-infos {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        @media (max-width: 991px) {
            align-items: flex-start;
            margin-top: 20px;
        }
    }

    &-info {
        display: flex;
        justify-content: flex-start;
        gap: 60px;
        align-items: center;

        @media (max-width: 991px) {
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 27px;
        }

        &-label {
            display: flex;
            align-items: center;
            gap: 10px;

            p {
                padding: 0;
                margin: 0;
                font-size: 22px;
                font-family: 'Font Regular', sans-serif;

                @media screen and (max-width: 991px) {
                    font-size: 22px;
                }
            }

            @media screen and (max-width: 991px) {
                svg {
                    width: 36px;
                    height: 36px;
                }
            }
        }

        &-date {
            display: flex;
            align-items: center;
            gap: 10px;

            p {
                padding: 0;
                margin: 0;
                font-size: 22px;
                font-family: 'Font Regular', sans-serif;

                @media screen and (max-width: 768px) {
                    font-size: 18px;
                }

                @media screen and (max-width: 576px) {
                    font-size: 16px;
                }
            }

            @media screen and (max-width: 768px) {
                svg {
                    width: 20px;
                    height: 20px;
                }
            }

            @media screen and (max-width: 576px) {
                svg {
                    width: 18px;
                    height: 18px;
                }
            }
        }

        &-btn {
            display: flex;
            align-items: center;
            gap: 30px;

            .save-btn {
                background-color: var(--green-medium);
                width: 140px;
                height: 45px;
                border-radius: 10px;
                border: 1px solid var(--green-medium);
                color: white;
                font-size: 18px;
                font-family: 'Font Regular';
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
                outline: none;
                box-shadow: none;
                transition: 500ms;
                &:hover {
                    cursor: pointer;
                    opacity: 0.8;
                }
                p {
                    padding: 0;
                    margin: 0;
                }
            }
            .is-save {
			background: var(--white);
                p {
                    color: var(--green-medium);
                }
            }

            .shared-btn {
                @media (max-width: 991px) {
                    display: none;
                }

            }
        }
    }
}
.content-blog-article {
    margin-top: 50px;
    text-align: justify;
    color: #112D23;
    &-title {
        h2{
            font-size: 30px!important;
            font-family: 'Font Bold', sans-serif;
            margin-bottom: 2rem;
            @media screen and (max-width: 991px) {
                font-size: 20px!important;
            }

        }
    }

    .content-news {
        @media (max-width: 991px) {
            display: none;
        }
    }

    &-text {
        p {
            font-size: 22px;
            font-family: 'Font Regular', sans-serif;
            gap: 20px;
            margin-bottom: 2rem;

            @media screen and (max-width: 991px) {
                font-size: 18px;
            }
        }
    }
}
.content-blog-comments {
    margin-block: 92px 125px;

    @media (max-width: 991px) {
        margin-block: 56px 95px;
    }

    &-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;


        @media (max-width: 991px) {
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 40px;
        }

        h2 {
            font-size: 28px;
            font-family: 'Font Bold';
            color: var(--green-medium);
        }

        .btn-comments {
            background-color: var(--green-medium);
            width: 251px;
            height: 45px;
            border-radius: 10px;
            color: white;
            font-size: 18px;
            font-family: 'Font Regular';

            display: flex;
            align-items: center;
            justify-content: center;

            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

            &:hover {
                background-color: white;
                color: var(--green-medium);
                transition: all 0.3s ease-in-out;
                border: 1px solid var(--green-medium);
            }
        }
    }

    &-body {
        display: flex;
        flex-direction: column;
        gap: 60px;

        @media (max-width: 991px) {
            gap: 40px;
        }

        &-box {
            border: 1px solid #E7E7E7;
            border-radius: 10px;

            display: flex;
            align-items: flex-start;
            gap: 50px;

            padding: 24px 20px 24px 20px;

            @media (max-width: 991px) {
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 17px;
            }

            &-name {
                font-size: 22px;
                font-family: 'Font Regular';
                color: #B7B8B8;

                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 6px;
                width: 140px;

                @media (max-width: 991px) {
                    font-size: 18px;
                }

                h3 {
                    font-size: 22px;
                    font-family: 'Font Regular';

                    @media (max-width: 991px) {
                        font-size: 18px;
                    }
                }
            }

            &-text {
                font-size: 22px;
                font-family: 'Font Regular';
                color: #555555;
                text-align: justify;
                width: calc(100% - 20%);

                @media (max-width: 991px) {
                    font-size: 18px;
                }
            }
        }


    }
	.btn-more {
			background-color: var(--green-medium);
			width: 133px;
			height: 45px;
			border-radius: 10px;
			color: white;
			font-size: 18px;
			font-family: 'Font Regular';

			display: flex;
			align-items: center;
			justify-content: center;

			margin: auto;
			margin-top: 40px;

			box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

			&:hover {
					background-color: white;
					color: var(--green-medium);
					transition: all 0.3s ease-in-out;
					border: 1px solid var(--green-medium);
			}
	}
}
.highlight {
	margin-bottom: 3rem;
	padding: 0;
}
.content-title-highlight {
    width: 100%;
    text-align: left;
    padding: 20px 15px;

    h2 {
        color: var(--green-medium);
        font-size: 40px;
        font-family: 'Font Bold', sans-serif;

        @media screen and (max-width: 991px) {
            font-size: 28px;
            font-family: 'Font Regular';
            color: #112D23;
        }
    }
}
.content-highlight {
    margin-bottom: 1rem;
		transition: 500ms;
		&:hover,&:focus {
			cursor: pointer;
			opacity: 0.8;
		}
    @media screen and (max-width: 992px) {
        flex-direction: column !important;
        flex: 0 0 100% !important;
        max-width: 100% !important;
    }

    &-item {
        position: relative;
        gap: 15px;
        padding: 10px 0;
        display: flex;

        @media screen and (max-width: 991px) {
            height: auto;
        }

        img {
            width: 169px;
            height: 178px;
            border-radius: 10px;
            object-fit: cover;
            @media screen and (max-width: 991px) {
                width: 112px;
                height: 130px;
            }
        }

        &-text {
            text-align: left;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            color: #112D23;

            &-date {
                display: flex;
                gap: 10px;
                align-items: center;

                @media (max-width: 991px) {
                    display: none;
                }

                p {
                    padding: 0;
                    margin: 0;
                    font-size: 18px;
                    font-family: 'Font Regular', sans-serif;
                }
            }

            h3 {
                font-size: 24px;
                font-family: 'Font Bold', sans-serif;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;

                @media screen and (max-width: 991px) {
                    font-size: 18px;

                }
            }

            p {
                width: calc(100% - 80px);
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                margin: 0;
                font-family: 'Font Regular', sans-serif;
                font-size: 18px;

                @media screen and (max-width: 991px) {
                    font-size: 18px;
                    width: calc(100% - 70px);
                }
            }
        }

        &-btn {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 72px;
            height: 53px;
            border: var(--green-medium) solid 1px;
            border-radius: 10px;
            background: none;
            bottom: 10px;
            right: 10px;
            cursor: pointer;

            @media screen and (max-width:991px) {
                width: 40px;
                height: 30px;

                svg {
                    width: 10px;
                    height: 10px;
                }
            }

            &:focus {
                outline: none;
            }
        }
    }
}
.content-news {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 15px 0;
    background-color: #F2F2F2;
    margin: 2rem 0;
}
</style>
